// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconWrseth } from "../../../icons/mono/build/icon-wrseth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const WrsethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconWrseth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  WrsethIcon.displayName = 'WrsethIcon';
}

export default WrsethIcon;